
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import vClickOutside from 'v-click-outside'

@Component<SurveyMenu>({
    directives: {
        clickOutside: vClickOutside.directive,
    },
})
export default class SurveyMenu extends Vue {
    @Prop(Boolean) public supportsClipboard!: boolean
    @Prop(Boolean) public isStaff!: boolean
    @Prop(Boolean) public isEditSurveyTemplates!: boolean
    @Prop(Function) public copyToClipboard!: () => void
    @Prop(Function) public pasteFromClipboard!: () => void
    @Prop(Function) public resetToDefault!: () => void
    @Prop(Function) public revertToClassic!: () => void

    public open = false

    public openMenu() {
        if (this.open) {
            return
        }

        this.open = true
    }

    public closeMenu() {
        if (!this.open) {
            return
        }

        this.open = false
    }
}
